import { Box, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { forwardRef, useEffect } from 'react';
import {
  ReadOnly,
  useEntityPermission,
  useFormPermissions,
} from '@ui-framework/index';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import TimeSlotsSelector from './TimeSlotsSelector';

const TimeSlotsAvaibilitySelector = forwardRef((props, ref) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext();
  const { isReadOnly } = useEntityPermission();
  const { permissions } = useFormPermissions();

  const SLOT_AVAILABILITY_OPTIONS = [
    {
      label: (
        <FormattedMessage
          id="NOT_AVAILABLE_FOR_ALL_SLOTS"
          defaultMessage="Not Available for all slots"
        />
      ),
      value: 'NOT_AVAILABLE',
    },
    {
      label: (
        <FormattedMessage
          id="NOT_AVAILABLE_FOR_LIMITED_SLOTS"
          defaultMessage="Not available for limited slots"
        />
      ),
      value: 'NOT_AVAILABLE_FOR_LIMITED_SLOTS',
    },
  ];

  const currentSlotAvailability = useWatch({
    control,
    name: 'slotAvailability',
  });

  useEffect(() => {
    if (currentSlotAvailability === 'NOT_AVAILABLE') {
      clearErrors('slotAvailability');
      clearErrors('slots');
    }
  }, [currentSlotAvailability]);

  if (isReadOnly(props?.permission, currentSlotAvailability)) {
    return (
      <Box>
        <ReadOnly name="currentSlotAvailability">
          {
            SLOT_AVAILABILITY_OPTIONS.find(
              s => s.value === currentSlotAvailability,
            ).label
          }
        </ReadOnly>
        {currentSlotAvailability === 'NOT_AVAILABLE_FOR_LIMITED_SLOTS' && (
          <Box>
            <TimeSlotsSelector
              permission={permissions?.slots}
              sx={{ marginLeft: '20px' }}
              name="slots"
              container={{
                name: 'slotAvailability',
                clearOnValue: 'NOT_AVAILABLE',
              }}
            />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Stack spacing={2} ref={ref}>
      <Controller
        control={control}
        name="slotAvailability"
        render={({ field }) => {
          return (
            <RadioGroup {...field}>
              {SLOT_AVAILABILITY_OPTIONS.map(item => {
                return (
                  <Stack
                    direction="column"
                    sx={{ alignItems: 'normal' }}
                    key={item.value}>
                    <FormControlLabel
                      value={item.value}
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          color:
                            item.value === 'NOT_AVAILABLE_FOR_LIMITED_SLOTS' &&
                            errors?.slots
                              ? 'error.main'
                              : 'text.primary',
                        },
                      }}
                      control={<Radio size="small" />}
                      label={item.label}
                    />
                    {item.value === 'NOT_AVAILABLE_FOR_LIMITED_SLOTS' ? (
                      <TimeSlotsSelector
                        permission={permissions?.slots}
                        disabled={
                          field.value !== 'NOT_AVAILABLE_FOR_LIMITED_SLOTS'
                        }
                        sx={{ marginLeft: '20px' }}
                        name="slots"
                        container={{
                          name: 'slotAvailability',
                          clearOnValue: 'NOT_AVAILABLE',
                        }}
                      />
                    ) : (
                      <input type="hidden" {...field} value={false} />
                    )}
                  </Stack>
                );
              })}
            </RadioGroup>
          );
        }}
      />
    </Stack>
  );
});

export default TimeSlotsAvaibilitySelector;
